export function duration(seconds: number | null): string {
  if (seconds === null || !Number.isFinite(seconds)) return "";
  const total = Math.round(seconds);
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return `${mins}:${String(secs).padStart(2, "0")}`;
}

/** Renders tempo as a claim that can fail, never as a guess (A9). */
export function tempo(track: {
  tempo: number | null;
  tempo_source: string | null;
  analysis_state: string | null;
}): { text: string; className: string; title: string } {
  if (track.tempo !== null) {
    const manual = track.tempo_source === "override";
    return {
      text: track.tempo.toFixed(1),
      className: manual ? "bpm manual" : "bpm",
      title: manual ? "set by hand" : "detected",
    };
  }
  switch (track.analysis_state) {
    case null:
      return { text: "–", className: "muted", title: "not analysed yet" };
    case "pending":
      return { text: "…", className: "muted", title: "queued for analysis" };
    case "failed":
      return { text: "!", className: "bad", title: "analysis failed" };
    case "skipped":
      // Detection never ran, so the fall-through's "confidence too low" would
      // be untrue. The track still plays; it just has no grid or peaks.
      return {
        // `no-tempo` lets a narrow phone column collapse this to a dash — the
        // sentence is worth its width on a desktop and not on a 390px screen.
        text: "not analysed",
        className: "muted nowrap no-tempo",
        title: "too long to analyse on this server",
      };
    default:
      return {
        text: "no steady tempo",
        className: "muted nowrap no-tempo",
        title: "detection confidence too low to assert a tempo",
      };
  }
}

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
